import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 mt-24 bg-[#0a0a0a]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2">
          <span className="font-heading text-3xl tracking-wide text-white">Relaxora</span>
          <p className="text-[#737373] text-sm mt-4 max-w-sm leading-relaxed">
            A premium directory of verified adult companions and agencies in Montenegro. 18+ only. Private by default.
          </p>
        </div>
        <div>
          <p className="text-overline mb-3">Platform</p>
          <ul className="space-y-2 text-sm text-[#a3a3a3]">
            <li><Link to="/directory" className="hover:text-white">Directory</Link></li>
            <li><Link to="/agencies" className="hover:text-white">Agencies</Link></li>
            <li><Link to="/wallet" className="hover:text-white">Wallet</Link></li>
            <li><Link to="/verification" className="hover:text-white">Verification</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-overline mb-3">Company</p>
          <ul className="space-y-2 text-sm text-[#a3a3a3]">
            <li><Link to="/support" className="hover:text-white">Contact support</Link></li>
            <li><a className="hover:text-white" href="#">Privacy & content policy</a></li>
            <li><a className="hover:text-white" href="#">Terms</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-xs text-[#737373] flex flex-col sm:flex-row gap-2 justify-between">
          <span>© {new Date().getFullYear()} Relaxora — Montenegro</span>
          <span className="text-gold tracking-widest">18+ ONLY • VERIFIED PROFILES</span>
        </div>
      </div>
    </footer>
  );
}
